"use strict";
/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @returns {Array} The array filled with exceptions.
 */

module.exports = function () {
    return [
    // Definite articles:
    "the",
    // Indefinite articles:
    "a", "an",
    // Numbers 1-10:
    "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten",
    // Demonstrative pronouns:
    "this", "that", "these", "those"];
};
//# sourceMappingURL=firstWordExceptions.js.map
//# sourceMappingURL=firstWordExceptions.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/english/firstWordExceptions.js
// module id = 455
// module chunks = 0